import { render, staticRenderFns } from "./JielongSettingCard.vue?vue&type=template&id=31d91313&scoped=true"
import script from "./JielongSettingCard.vue?vue&type=script&lang=ts"
export * from "./JielongSettingCard.vue?vue&type=script&lang=ts"
import style0 from "./JielongSettingCard.vue?vue&type=style&index=0&id=31d91313&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d91313",
  null
  
)

export default component.exports